import { EmployeesService } from '../../services/employees.service';
import { MasterdataAService, ShiftService } from "../../services/index";

export const subscriptionsState: aboTheme.IState = {

    parent: 'app',
    name: "subscriptions",
    url: "/subscriptions",
    redirectTo: "subscriptions.dashboard",
    component: 'subscriptionsComponent',
    data: {
        permissions: {
            only: ['EMPLOYEE']
        }
    }
};

export const subscriptionsDashboardState: aboTheme.IState = {

    name: "subscriptions.dashboard",
    url: "/dashboard?currentShiftId",
    params: {
        currentShiftId: null
    },
    resolve: {
        // shifts: (ShiftService: ShiftService) => { 
        //     "ngInject";
        //     var moment = require('moment');
        //     var startDate = moment().toDate();
        //     var endDate = moment().add(30, 'day').toDate();
        //     return ShiftService.getLightByDate({start: startDate, end: endDate});
        // },
        subscriptions: (EmployeesService: EmployeesService) => {
            "ngInject";
            return EmployeesService.getSubscriptions();
        },
        functions : (MasterdataAService: MasterdataAService) => { "ngInject"; return MasterdataAService.getItems('Functions'); }
    },
    views: {
        "main": 'subscriptionsDashboardComponent'
    }
};

export const subscriptionsDashboardItemState = {
    name: "subscriptions.dashboard.item",
    url: "/item/:id",
    resolve: {
       
    },
    views: {
        "shiflistitem@subscriptions.dashboard": 'subscriptionsItemComponent'
    },
};


// WEBPACK FOOTER //
// ./src/app/modules/subscriptions/subscriptions.states.ts